import React from 'react'
import Skeleton from '@mui/material/Skeleton'

function SkeletonOrder () {
  return (
    <div style={{ padding: '48px 64px 30px' }}>
      <div style={{ display: 'flex' }}>
        <Skeleton variant='rectangular' width={115} height={111} display />
        <div style={{ flex: 1, marginLeft: '16px' }}>
          <Skeleton variant='text' />
          <Skeleton variant='text' height={54} />
        </div>
      </div>
      <Skeleton variant='text' style={{ marginTop: 8 }} />
    </div>
  )
}

export default SkeletonOrder
